export function ShubhPayMark({ className = "h-8 w-8" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
      <rect width="100" height="100" rx="22" fill="#0D1B3E" />
      <path d="M22 68 L44 32 L58 52 L78 22" stroke="#10B981" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="78" cy="22" r="7" fill="#34D399" />
      <circle cx="22" cy="68" r="5.5" fill="#F59E0B" />
    </svg>
  );
}

export default function Logo({ dark = false, size = "text-lg", mark = "h-8 w-8" }) {
  return (
    <span className="inline-flex items-center gap-2">
      <ShubhPayMark className={mark} />
      <span className={`font-display font-extrabold tracking-tight ${size} ${dark ? "text-white" : "text-[#0D1B3E]"}`}>
        Shubh<span className="text-emerald-500">Pay</span>
      </span>
    </span>
  );
}
